import React from 'react';

export default function Foot() {
    return(
        <div className='footer'>
            <span>Photography by <a href='https://unsplash.com/@anniespratt' target="_blank" rel="noopener noreferrer">Annie Spratt</a></span>
        </div>
    )
}
